import { Type } from '@sinclair/typebox';
export const priceSchema = Type.Object({
    amountInclTax: Type.Number(),
    amountExclTax: Type.Number(),
    taxPercentage: Type.Number(),
});
export const priceSchemaNoTaxPerc = Type.Object({
    amountInclTax: Type.Number(),
    amountExclTax: Type.Number(),
});
export const priceMajorMinorSimpleSchema = Type.Object({
    major: Type.Number(),
    minor: Type.Number(),
});
export const priceMajorMinorInclOnlySchema = Type.Object({
    major: Type.Object({
        amountInclTax: Type.Number(),
    }),
    minor: Type.Object({
        amountInclTax: Type.Number(),
    }),
});
export const priceMajorMinorSchema = Type.Object({
    major: Type.Object({
        amountInclTax: Type.Number(),
        amountExclTax: Type.Number(),
    }),
    minor: Type.Object({
        amountInclTax: Type.Number(),
        amountExclTax: Type.Number(),
    }),
    taxPercentage: Type.Number(),
});
export const shippingMethodPriceSchema = Type.Object({
    total: priceMajorMinorSchema,
    delivery: priceMajorMinorSchema,
    handling: priceMajorMinorSchema,
    discount: priceMajorMinorInclOnlySchema,
});
export const shippingMethodPriceSchemaV2 = Type.Object({
    delivery: Type.Object({
        amount: Type.Number(),
        discountAmount: Type.Number(),
    }),
    handling: Type.Object({
        amount: Type.Number(),
        discountAmount: Type.Number(),
    }),
});
//# sourceMappingURL=price.js.map